import {Component, ElementRef, inject, input, signal, viewChild, WritableSignal} from '@angular/core';
import {TypedBaseWidgetComponent} from '@core/instantsearch/types-based-widget';
import {
  SearchBoxConnectorParams,
  SearchBoxRenderState,
  SearchBoxWidgetDescription
} from 'instantsearch.js/es/connectors/search-box/connectSearchBox';
import {noop} from 'instantsearch.js/es/lib/utils';
import {connectSearchBox} from 'instantsearch.js/es/connectors';
import {InstantSearchComponent} from '@core/instantsearch/components/instantsearch.component';

@Component({
  selector: 'app-instantsearch-search-box',
  standalone: true,
  template: ''
})
export class InstantSearchSearchBoxComponent extends TypedBaseWidgetComponent<SearchBoxWidgetDescription, SearchBoxConnectorParams> {
  instantSearchInstance = inject(InstantSearchComponent);

  readonly searchBox = viewChild<ElementRef>('searchBox');
  public readonly searchAsYouType = input<boolean>(true);

  public override state: WritableSignal<SearchBoxRenderState> = signal({
    query: '',
    refine: noop,
    clear: noop,
    isSearchStalled: false,
  });

  constructor() {
    super('SearchBox');
    this.createWidget(connectSearchBox, {});
  }


}
